import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { Colligate } from "../types";

export const UPDATE_QUERY = print(gql`
  mutation UpdateCategoryConversion($data: UpdateCategoryConversionInput!) {
    updateCategoryConversion(data: $data) {
      id
      colligate {
        id
        databaseName
        description
        active
        partnerVisibleName
        createdAt
        updatedAt
      }
      idColligate
      databaseName
      idCourseType
      idBranch
      categorySlug
      createdAt
      updatedAt
    }
  }
`);

export interface UpdateGql {
  updateCategoryConversion: {
    id: number;
    colligate: Colligate;
    databaseName: string;
    idColligate: number;
    idCourseType: number;
    idBranch: number;
    categorySlug: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
